<template functional>
	<div @click="props.has_options ? null : props.on_click()" :id="`room-controls-button-${props.name}`" :class="[{'disabled': props.disabled}, {'active': props.active || props.options_is_open}, {'button-wrapper-sm': props.hide_label }, 'tw-flex tw-justify-center tw-py-2 tw-px-9-5 tw-transition-opacity button-wrapper tw-relative']">
		<slot></slot>

		<div
            @click="props.has_options ? props.on_click() : null"
			class="tw-flex tw-flex-col tw-justify-end tw-items-center tw-p2 tw-text-white button"
			:class="{'small-button': props.hide_label}"
		>
			<i class="fas icon" :class="$options.getValue(props.icon_class, props.is_muted)"></i>
			<span class="tw-select-none tw-text-center tw-hidden md:tw-block button-label" :class="{'hide': props.hide_label}">{{ $options.getValue(props.label, props.is_muted) }}</span>
		</div>

		<i v-if="props.has_options" @click="props.on_chevron_click" class="far tw-text-white tw-p-1.5 chevron"
		   :class="[props.options_is_open ? 'fa-chevron-up' : 'fa-chevron-down', {'chevron-sm': props.hide_label}]"/>
	</div>
</template>

<script>
export default {
	name: 'ToolbarButton',
	props: {
		active: {
			type: Boolean,
			default: false,
		},
		color: {
			required: false,
			type: String,
			default: "#C3C3C3"
		},
		disabled: {
			required: false,
			type: Boolean,
			default: false,
		},
		has_options: {
			required: false,
			type: Boolean,
			default: false,
		},
		icon_class: {
			required: true,
			type: String | Array,
		},
		is_muted: {
			required: false,
			type: Boolean,
		},
		label: {
			required: true,
			type: String | Array,
		},
		name: {
			required: true,
			type: String
		},
		on_chevron_click: {
			required: false,
		},
		on_click: {
			required: false,
		},
		options_is_open: {
			required: false,
			type: Boolean,
			default: false,
		},
		hide_label: {
			required: false,
			type: Boolean,
		}
	},
	getValue(val, is_muted) {
		if (!Array.isArray(val)) return val;
		return is_muted ? val[0] : val[1];
	},
};
</script>

<style lang="scss" scoped>
button:hover {
	background-color: #F7F7F7;
}
.icon {
	font-size: 1.143em;
}
.button {
	gap: 4px;
	min-width: 3.714rem;
}

.chevron {
    width: 12px;
    height: 12px;
    font-size: 0.571em;
    font-weight: 600;
    text-align: center;
    line-height: 13px;
    border-radius: 100%;
    position: absolute;
    top: 8px;
    right: 7px;
}

.chevron:hover {
    background: rgba(255, 255, 255, 0.3);
}

.chevron-sm {
    top: 15px;
    right: 0px;
}

@media (max-width: 767px) {
	.button {
		gap: 2px;
		min-width: 0;
	}

    .button-wrapper {
        width: 45px;
        height: 45px;
        display: flex;
        align-items: center;
    }

    .chevron {
        top: 15px;
        right: 0px;
    }
}

.button-wrapper-sm {
    width: 45px;
    height: 45px;
    display: flex;
    align-items: center;
}

.button-label {
	font-size: 0.857rem;
	font-weight: 600;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
.hide {
	display: none !important;
}
.small-button {
	gap: 2px !important;
	min-width: 0 !important;
}

.tw-px-9-5 {
	padding-left: 0.679rem;
	padding-right: 0.679rem;
}
.button-wrapper {
    border-radius: 32px;
    cursor: pointer;
}

.button-wrapper:hover {
	background: rgba(255, 255, 255, 0.1);
    cursor: pointer;
}

.button-wrapper:active {
    background: rgba(255, 255, 255, 0.2);
}
.translate {
	transform: translate(-18px, -4px);
}
.active {
	background: rgba(255, 255, 255, 0.2);
	border-radius: 32px;
}
.disabled {
    opacity: 0.2;
    pointer-events: none;
}
</style>
